import {focusBlock} from '../highlight.jsx';
import event, {EVENTS} from '../../lib/event';
import {useTouchInteraction, onClick} from '../utils';
import Audio from '../../lib/audio.js';
import Cartoon from '../avatar-action';
import {selectElement} from "../../lib/utils";
import {BATCH_TIPS_MODE, GUIDE_MODE} from '../../lib/constant';
import showOptions from './show-options';

/**
 * 聚焦到某个元素，点击任意位置进入下一步
 * @param {string|function} element - 需要点击的元素的element、 element selector 或者是一个方法返回 element dom
 * @param {number} index - 当element为string类型的selector时，表示第几个匹配
 * @param {left, top, width, height} args.sourceOffset - 偏移量
 * @param {number} args.zIndex - 设置 z-index，默认值为 999
 * @param {string} tips - 提示，默认为`点击这里`
 * @param {string} pointerEvents - 焦点透传鼠标事件的属性，默认为auto
 * @param options - 选择题选项
 * @returns {Promise} 执行成功的 Promise，这个方法不可能失败
 */
export default function focusElement ({element: _element, index, zIndex, offset, tips, pointerEvents, options}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    return new Promise(async (resolve, reject) => {
        const onAbort = ()=>{
            reject('Step Abort');
            event.emit(EVENTS.CLEAR_COVER);
        };
        event.once(EVENTS.STEP_ABORT, onAbort);

        const wrapResolve = arg => {
            event.off(EVENTS.STEP_ABORT, onAbort);
            resolve(arg);
        }
        const wrapReject = arg => {
            event.off(EVENTS.STEP_ABORT);
            reject(arg);
        }
        let element = await selectElement(_element, index);
        if (element) {
            if (!tips) {
                tips = "查看高亮位置，点击任意位置继续";
            }
            if (mode) {
                if (mode === BATCH_TIPS_MODE) {
                    if (options) {
                        showOptions({tips, options}, mode, _index).then(wrapResolve, wrapReject);
                    }else {
                        window.stepsRuntime.insertTips(_index, tips, true);
                        wrapResolve();
                        return;
                    }
                }
            }

            await focusBlock({source: element, sourceOffset: offset, tips, zIndex, pointerEvents: pointerEvents || 'auto', reject: wrapReject}, mode, _index);
            if (options) {
                showOptions({tips, options}, mode, _index).then(arg => {
                    event.emit(EVENTS.CLEAR_COVER);
                    wrapResolve(arg);
                }, wrapReject);
            }else {
                if (mode) {
                    window.stepsRuntime.insertTips(_index, tips, true);
                    if (mode != BATCH_TIPS_MODE) {
                        window.stepsRuntime.addContinueButton();
                    }
                }
                event.once(EVENTS.BG_CLICK, () => {
                    event.emit(EVENTS.CLEAR_COVER);
                    wrapResolve({autoNext: true}); //自动进入下一步
                });
            }
        } else {
            tips = '目标「' + _element + '[' + index + ']」未找到，自动转入下一步';
            if (mode) {

                if (mode === GUIDE_MODE) {
                    window.stepsRuntime.insertTips(_index, tips, true);
                    //reject(tips);
                    wrapResolve();
                }else { //非引导模式下不显示错误
                    wrapResolve();
                }
            }else {
                Audio.tts(tips);
                //reject();
                wrapResolve();
            }
            console.warn(`element 未找到: `, _element, index);
        }
    });
}
